import { config } from "../../../config/utils";
import { LoginResponse } from "../interfaces/UserAuthenticated"


/**
 * Funcion que autentica al usuario para poder utilizar los demas endpoints de la api picklog
 * @param username Nombre del seller
 * @param password Password del seller
 * @returns Promise que resuelve con un mensaje de informacion y setea en el navegador una cookie httpOnly
 */


export const fetchLogin = async(username: string, password: string): Promise<LoginResponse | null> => {
    try {
        
        const response = await fetch(`${config.URL_PICKLOG}/sessions/login`, {
        // const response = await fetch('http://localhost:8080/api/sessions/login', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            credentials: 'include',
            body: JSON.stringify({
                seller_name: username,
                password: password
            })
        })

        if(!response.ok) throw new Error(`HTTP error! Status: ${response.status}`)
        const data = await response.json() as LoginResponse;
        return data

    } catch (error) {
        console.log(error)
        return null
    }
}
